module.exports = __webpack_public_path__ + "img/twix.4401b5ef.jpg";